const fadeDurationMs = 150;
const button = "_61b15laz91";
const container = "_61c14mz4b5";
const icon = "_61i78rwiu";

export { button, container, fadeDurationMs, icon };
import "./atom.favourite-button.style.linaria.module.css";
//# sourceMappingURL=atom.favourite-button.style.js.map
